export enum UserRoles {
    Admin = 'cms-admin',
    Editor = 'cms-editors',
    Yougov = 'cms-yougov',
}
